import React from 'react';

const TermsOfUse = () => {
  return (
    <div style={{ padding: '1rem', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Terms of Use</h1>

      <p>
        By using isLike (“the Service”), you agree to be bound by these Terms of Use, as well as
        any applicable policies referenced herein (including Google’s Terms of Service if you
        use our Google-integrated features). If you do not agree to all of these terms, do not
        use the Service.
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        Your use of isLike is subject to these Terms of Use. We may modify these terms at any time,
        and such modifications will be effective immediately upon posting to this page. Your
        continued use of the Service after such changes constitutes acceptance of the modified terms.
      </p>

      <h2>2. Eligibility and Age Requirement</h2>
      <p>
        You must be at least 13 years old to use this Service. By using or registering for the
        Service, you represent and warrant that you meet this age requirement.
      </p>

      <h2>3. Third-Party Services (Google Maps & Analytics)</h2>
      <p>
        This application uses the Google Maps Platform and related APIs. By using our Service,
        you acknowledge and agree to be bound by
        <a
          href="https://maps.google.com/help/terms_maps.html"
          target="_blank"
          rel="noreferrer"
          style={{ marginLeft: '0.25rem' }}
        >
          Google’s Terms of Service
        </a>.
      </p>
      <p>
        We also use Google Analytics (or similar analytics tools) to understand how users interact
        with the Service. Usage of these analytics tools is subject to their respective terms
        and policies, and may involve the use of cookies. Please see our Privacy Policy for more
        details on how we handle your data.
      </p>

      <h2>4. User Conduct</h2>
      <p>
        You agree not to misuse the Service. For example, you must not attempt to interfere with
        the Service or access it using a method other than the interface and instructions that we
        provide. You must comply with all applicable laws and regulations.
      </p>

      <h2>5. Disclaimer of Warranties</h2>
      <p>
        The Service is provided “as is.” isLike disclaims all warranties, express or implied,
        including any implied warranties of merchantability, fitness for a particular purpose,
        and non-infringement.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, isLike shall not be liable for any direct, indirect,
        incidental, special, or consequential damages resulting from the use or inability to use
        the Service, even if we have been advised of the possibility of such damages.
      </p>

      <h2>7. Changes to Terms</h2>
      <p>
        We may modify these Terms of Use at any time. Continued use of the Service implies acceptance
        of the modified terms.
      </p>

      <p style={{ marginTop: '2rem' }}>
        Last updated: March 5, 2025
      </p>
    </div>
  );
};

export default TermsOfUse;
